import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Formatter {

    public static getFinanceDisplayPrice(price: number): string {
        return Number(price) ? `$${price}/mo` : '';
    }

    public static getDisplayPrice(price: number): string {
        return Number(price) ? `$${price}` : '';
    }

    public static formatCycleDuration(cycleStartDate: string, cycleEndDate: string, withYear: boolean = false): string {
        const startDate: string = new Date(cycleStartDate).toLocaleDateString('en-EN', {
            month: 'short',
            day: 'numeric'
        });

        const endDate: string = new Date(cycleEndDate).toLocaleDateString('en-EN', {
            month: 'short',
            day: 'numeric',
            year: withYear ? 'numeric' : undefined
        });

        return `${startDate} - ${endDate}`;
    }

    // format date in YYYY-MM-DD
    public static formatDate(date: string): string {
        const d: Date = new Date(date);
        let month: string = '' + (d.getMonth() + 1).toString();
        let day: string = '' + d.getDate().toString();
        const year: number = d.getFullYear();
        const TWO: number = 2;

        if (month.length < TWO) {
            month = '0' + month;
        }

        if (day.length < TWO) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }

    public static formatDateWithTime(date: string): string {
        const d: Date = new Date(date);
        const time: string = d.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
        const day: string = d.toLocaleString('en-US', { month: 'short', day: '2-digit' });

        return time + ' on ' + day;
    }

    //format time in HH:MM
    public static formatTime(date: string): string {
        const d: Date = new Date(date);
        const hours: string = d.getHours().toString().padStart(2, '0');
        const minutes: string = d.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    //format date in Month day, year. eg. Oct 9, 2022
    public static formatMonthDateYear(date: string): string {
        const d: Date = new Date(date);

        return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }

    public static formatMonthDate(date: string): string {
        const d: Date = new Date(date);

        return d.toLocaleString('en-US', { month: 'short', day: 'numeric' });
    }

    public static formatDateToMDY(date: string): string {
        const d: Date = new Date(date);
        const month: number = d.getMonth() + 1;
        const day: number = d.getDate();
        const year: number = d.getFullYear();

        return `${month}/${day}/${year}`;
    }


    public static formatLongDateWithOrdinal(date: string): string {
        const d: Date = new Date(date);

        if (isNaN(d.getTime())) {
            return '';
        }

        const month: string = d.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
        const day: number = d.getUTCDate();
        const year: number = d.getUTCFullYear();
        const ordinalSuffixes: { [key: number]: string } = { 1: 'st', 2: 'nd', 3: 'rd' };
        const ordinalSuffix: string = day % 100 >= 11 && day % 100 <= 13
            ? 'th'
            : ordinalSuffixes[day % 10] || 'th';

        return `${month} ${day}${ordinalSuffix} ${year}`;
    }

    public static formatMonthDay(date: string): string {
        if (!date) {
            return '';
        }
        const d: Date = new Date(date);

        return d.toLocaleString('en-US', { month: 'long', day: 'numeric' });
    }

    public static formatTimeRange(startDate: string, endDate: string): string {
        if (!startDate || !endDate) {
            return '';
        }
        const startTime: string = Formatter.formatTimeAmPm(startDate);
        const endTime: string = Formatter.formatTimeAmPm(endDate);

        return `${startTime}-${endTime}`;
    }

    public static formatTimeAmPm(date: string): string {
        if (!date) {
            return '';
        }
        const d: Date = new Date(date);

        return d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase().replace(' ', '');
    }

}
